(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rare-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const thumb=event.target.closest('[data-photo]');
  if(thumb){
    const gallery=thumb.closest('.product-gallery');
    gallery.querySelectorAll('.product-image').forEach(image=>{image.hidden=image.id!==thumb.dataset.photo});
    gallery.querySelectorAll('[data-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));
  }
  const zoom=event.target.closest('[data-zoom]');
  if(zoom){const dialog=document.getElementById('product-zoom');dialog.querySelector('.zoomed-image').src=zoom.dataset.zoom;dialog.showModal();}
  if(event.target.closest('[data-close-zoom]'))document.getElementById('product-zoom').close();
  if(event.target instanceof HTMLDialogElement){const bounds=event.target.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)event.target.close();}
  if(event.target.closest('.menu a'))event.target.closest('.menu').open=false;
});
document.addEventListener('change',function(event){if(event.target.matches('[data-variant-picker]')){const url=new URL(location.href);url.searchParams.set('variant',event.target.value);location.assign(url.href);}});

  } catch(e) { console.error(e); }
})();
})();
